<template>
  <ListItemsController
    allow_create
    allow_delete
    allow_edit
    allow_sort

    :label="$t('Интервалы')"
    v-model="items"
    :original_value="original_value"
    :default_item="{
      day_of_week: [],
      is_workday: true,
      mode: 'DAYOFWEEK',
      str_date_start: '',
      str_date_end: '',
      str_time_start: '00:00',
      str_time_end: '00:00'
    }"
  >  
    <template #list-item="{ item }">
      <v-list-item-avatar >
        <v-icon v-if="item.is_workday">mdi-chart-gantt</v-icon>
        <v-icon v-else>mdi-close</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>{{item.mode == 'DAYOFWEEK' ? formatWeekdays(item) : formatDates(item)}}</v-list-item-title>
        <v-list-item-subtitle v-if="item.is_workday"><T>Время работы</T>: {{item.str_time_start}} - {{item.str_time_end}}</v-list-item-subtitle>    
        <v-list-item-subtitle v-else><T>Нерабочее время</T></v-list-item-subtitle>
      </v-list-item-content>
    </template>

    <template #dialog="{ item, is_new, submit, remove }">
      <IntervalEditor 
        :is_new="is_new"
        :value="item"
        @input="v => Object.entries(v).forEach(([k,v]) => item[k] = v)"
        @remove="remove"
        @save="submit"
      />
    </template>
  </ListItemsController>
</template>

<script>
import ListItemsController from '../../common/ListItemsController.vue'
import IntervalEditor from './IntervalEditor.vue'

export default {
  props: ['value', 'original_value'],
  methods: {
    formatWeekdays(interval) {
      return [...interval.day_of_week].sort().map(el => this.days[el]).join(', ')
    },
    formatDates(interval) {
      if (interval.str_date_start == interval.str_date_end) {
        return this.formatDate(new Date(interval.str_date_start))
      } else {
        return `${this.formatDate(new Date(interval.str_date_start))} - ${this.formatDate(new Date(interval.str_date_end))}`
      }
    },
    fillLen(str, len) {
      
      while (str.length < len) {
        str = `0${str}`
      }

      return str
    },
    formatDate(date){
      return `${this.fillLen(''+date.getDate(), 2)}.${this.fillLen(''+ (date.getMonth()+1), 2)}.${date.getFullYear()}`
    }
  },
  computed: {
    days(){
      return [
        this.$t('пн'),
        this.$t('вт'),
        this.$t('ср'),
        this.$t('чт'),
        this.$t('пт'),
        this.$t('сб'),
        this.$t('вс'),
      ]
    },
    items: {
      get(){
        return this.value || []
      },
      set(v){
        this.$emit('input', v)
      }
    }
  },
  components: {
    ListItemsController,
    IntervalEditor
  }
}
</script>